/* eslint-disable no-shadow */
var ButtonSizesEnum;
(function (ButtonSizesEnum) {
    ButtonSizesEnum["xsmall"] = "x-small";
    ButtonSizesEnum["small"] = "small";
    ButtonSizesEnum["medium"] = "medium";
    ButtonSizesEnum["large"] = "large";
    ButtonSizesEnum["xlarge"] = "x-large";
})(ButtonSizesEnum || (ButtonSizesEnum = {}));
var ButtonStyleTypeEnum;
(function (ButtonStyleTypeEnum) {
    ButtonStyleTypeEnum["link"] = "link";
    ButtonStyleTypeEnum["ghost"] = "ghost";
    ButtonStyleTypeEnum["primary"] = "primary";
    ButtonStyleTypeEnum["secondary"] = "secondary";
    ButtonStyleTypeEnum["danger"] = "danger";
    ButtonStyleTypeEnum["outline"] = "outline";
    ButtonStyleTypeEnum["pill"] = "pill";
})(ButtonStyleTypeEnum || (ButtonStyleTypeEnum = {}));

export { ButtonSizesEnum, ButtonStyleTypeEnum };
